/* eslint-disable no-mixed-spaces-and-tabs */
import { createSelector } from 'reselect';
import { isEmpty } from 'lodash';
import { initialState } from './reducer';

export const selectGroupsContainerDomain = state => state.orderGroupsContainerReducer || initialState;

export const getIsGroupsListLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isGroupsListLoading }) => isGroupsListLoading);

export const getGroupsListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ groupsList }) => {
		if (!groupsList || groupsList.length === 0) {
			return [];
		}

		return groupsList.map(group => ({
			...group,
			name: group.name || '',
		}));
	});

export const getIsGroupsWithWaysListLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isGroupsWithWaysListLoading }) => isGroupsWithWaysListLoading);

export const getGroupsWithWaysListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ groupsWithWaysList }) => {
		if (!groupsWithWaysList || groupsWithWaysList.length === 0) {
			return [];
		}

		return groupsWithWaysList.map(group => ({
			...group,
			name: group.name || '',
		}));
	});

export const getGroupsOptionsSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ groupsList }) => {
		return groupsList
			? groupsList
					.filter(el => !el.process)
					.map(value => ({ key: value?.id, text: value?.name, value: value?.id }))
			: [];
	});

export const getWaysOptionsSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ waysList }) => {
		return waysList
			? waysList
					.filter(el => !el.planning)
					.map(value => ({ key: value?.id, text: value?.name, value: value?.id }))
			: [];
	});

export const getWaysListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ waysList }) => {
		if (!waysList || waysList.length === 0) {
			return [];
		}

		return waysList.map(way => ({
			...way,
			name: way.name || '',
		}));
	});

export const getIsWaysListLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isWaysListLoading }) => isWaysListLoading);

export const getTypesSelector = () => createSelector(selectGroupsContainerDomain, ({ types }) => types);

export const getIsTypesLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isTypesLoading }) => isTypesLoading);

export const getIsCollectionGroupListLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isCollectionGroupListLoading }) => isCollectionGroupListLoading);

export const getCollectionGroupListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ collectionGroupList }) => {
		if (!collectionGroupList || isEmpty(collectionGroupList)) {
			return [];
		}

		return collectionGroupList.map(collection => ({
			...collection,
			region_from: collection.points[0]?.address?.region_with_type || '',
			address_from: collection.points[0]?.address || '',
			region_to: collection.points[1]?.address?.region_with_type || '',
			address_to: collection.points[1]?.address || '',
		}));
	});

export const getIsOrdersCollectionGroupListLoadingSelector = () =>
	createSelector(
		selectGroupsContainerDomain,
		({ isOrdersCollectionGroupListLoading }) => isOrdersCollectionGroupListLoading,
	);

export const getOrdersCollectionGroupListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ ordersCollectionGroupList }) => {
		if (!ordersCollectionGroupList || isEmpty(ordersCollectionGroupList)) {
			return [];
		}

		return ordersCollectionGroupList.map(order => ({
			...order,
			number: order.number || '',
			region_from: order.points[0]?.address?.region_with_type || '',
			address_from: order.points[0]?.address || '',
			region_to: order.points[1]?.address?.region_with_type || '',
			address_to: order.points[1]?.address || '',
			cost: order.cost,
		}));
	});

export const getIsWaysGroupListLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isWaysGroupListLoading }) => isWaysGroupListLoading);

export const getWaysGroupListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ waysGroupList }) => {
		if (!waysGroupList || isEmpty(waysGroupList)) {
			return [];
		}

		return waysGroupList;
	});

export const getIsCollectionWayListLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isCollectionWayListLoading }) => isCollectionWayListLoading);

export const getCollectionWayListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ collectionWayList }) => {
		if (!collectionWayList || isEmpty(collectionWayList)) {
			return [];
		}

		return collectionWayList.map(collection => ({
			...collection,
			region_from: collection.points[0]?.address?.region_with_type || '',
			address_from: collection.points[0]?.address || '',
			region_to: collection.points[1]?.address?.region_with_type || '',
			address_to: collection.points[1]?.address || '',
		}));
	});

export const getIsOrdersCollectionWayListLoadingSelector = () =>
	createSelector(
		selectGroupsContainerDomain,
		({ isOrdersCollectionWayListLoading }) => isOrdersCollectionWayListLoading,
	);

export const getOrdersCollectionWayListSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ ordersCollectionWayList }) => {
		if (!ordersCollectionWayList || isEmpty(ordersCollectionWayList)) {
			return [];
		}

		return ordersCollectionWayList.map(order => ({
			...order,
			number: order.number || '',
			region_from: order.points[0]?.address?.region_with_type || '',
			address_from: order.points[0]?.address || '',
			region_to: order.points[1]?.address?.region_with_type || '',
			address_to: order.points[1]?.address || '',
			cost: order.cost,
		}));
	});

export const getModesSelector = () => createSelector(selectGroupsContainerDomain, ({ modes }) => modes);

export const getIsModesLoadingSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ isModesLoading }) => isModesLoading);

export const getIsLoadingSelector = () => createSelector(selectGroupsContainerDomain, ({ isLoading }) => isLoading);

export const getGroupOpenSelector = () => createSelector(selectGroupsContainerDomain, ({ groupOpen }) => groupOpen);

export const getCollectionGroupOpenSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ collectionGroupOpen }) => collectionGroupOpen);

export const getGroupWayOpenSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ groupWayOpen }) => groupWayOpen);

export const getWayOpenSelector = () => createSelector(selectGroupsContainerDomain, ({ wayOpen }) => wayOpen);

export const getCollectionWayOpenSelector = () =>
	createSelector(selectGroupsContainerDomain, ({ collectionWayOpen }) => collectionWayOpen);
